/*
 *
 * DivisionsImport actions
 *
 */

import {
  GET_TEMPLATE_DIVISION_WATCHER,
  GET_TEMPLATE_SUCCESS,
  GET_TEMPLATE_FAILED,
  UPLOAD_TEMPLATE_WATCHER,
  UPLOAD_TEMPLATE_SUCCESS,
  UPLOAD_TEMPLATE_FAILED,
} from "./constants"

// UPLOAD TEMPLATE
export function uploadTemplate(payload) {
  return {
    type: UPLOAD_TEMPLATE_WATCHER,
    payload,
  }
}

export function uploadTemplateSuccess(payload) {
  return {
    type: UPLOAD_TEMPLATE_SUCCESS,
    payload,
  }
}

export function uploadTemplateFailed(payload) {
  return {
    type: UPLOAD_TEMPLATE_FAILED,
    payload,
  }
}

// GET TEMPLATE
export function getTemplateDivision(payload) {
  return {
    type: GET_TEMPLATE_DIVISION_WATCHER,
    payload,
  }
}

export function getTemplateSuccess(payload) {
  return {
    type: GET_TEMPLATE_SUCCESS,
    payload,
  }
}

export function getTemplateFailed(payload) {
  return { type: GET_TEMPLATE_FAILED }
}
